// ---------------------------------------
// SYNC WITH ADMIN/PARTIALS/IMAGE-DROPZONE
// ---------------------------------------

import React from "react";
import { FlatButton } from "material-ui";
import Dropzone from "react-dropzone";
import Cropper from "cropperjs";

import BaseOverlay from "../overlays/base.jsx";

// Polyfill toBlob() for Safari
import "blueimp-canvas-to-blob";

class ImageDropzone extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      droppedImage: null,
      cropper: null,
      fromImageUrl: false
    };

    this._onDrop = this._onDrop.bind(this);
    this._onCropCancel = this._onCropCancel.bind(this);
    this._onCropSubmit = this._onCropSubmit.bind(this);
  }

  // Public method
  showCropperForImage(image) {
    this._onDrop(
      [
        {
          preview: image
        }
      ],
      { fromImageUrl: true }
    );
  }

  _onDrop(files, opts = {}) {
    if (!files || !files.length || !files[0]) {
      return;
    }

    if (
      !(this.props.crop || this.props.allowEdit) ||
      files[0].type === "image/gif"
    ) {
      // Don't allow gif cropping, not supported by cropper.js
      this.props.onDrop(files);
    } else {
      this.setState(
        {
          droppedImage: files[0]
        },
        function() {
          let cropper = new Cropper(this._image, {
            viewMode: 1, // Don't allow crop to include empty space
            aspectRatio:
              this.props.crop &&
              this.props.crop.width &&
              this.props.crop.width / this.props.crop.height,
            autoCropArea:
              (!(this.props.crop && this.props.crop.width) &&
                this.props.allowEdit) ||
              !this.props.autoCropArea
                ? 1
                : this.props.autoCropArea // default to full image if no required crop
          });
          this.setState({
            cropper: cropper,
            fromImageUrl: opts.fromImageUrl
          });
        }
      );
    }
  }

  _onCropCancel() {
    this.setState({
      droppedImage: null
    });
  }

  _onCropSubmit() {
    const handleBlob = blob => {
      this.props.onDrop([blob], { fromImageUrl: this.state.fromImageUrl });
      this.setState({
        droppedImage: null,
        cropper: null
      });
    };

    if (this.props.dataUrl) {
      // This is slow, so we defer the dataUrl rendering til after we hide the modal
      // to make it *seem* instantaneous...
      this.setState({ droppedImage: null }, () => {
        setTimeout(() => {
          handleBlob(this.state.cropper.getCroppedCanvas().toDataURL());
        }, 0);
      });
    } else {
      this.state.cropper.getCroppedCanvas().toBlob(handleBlob);
    }
  }

  render() {
    return (
      <div>
        <BaseOverlay
          zIndex={2001}
          title={"Crop image"}
          openImmediately={true}
          actions={[
            <FlatButton label="Cancel" onClick={this._onCropCancel} />,
            <FlatButton label="Upload" onClick={this._onCropSubmit} />
          ]}
          modal={true}
          open={!!this.state.droppedImage}
          onRequestClose={this._handleCropCancel}
        >
          <div style={{ width: "100%", height: "300px" }}>
            {this.state.droppedImage ? (
              <img
                src={this.state.droppedImage.preview}
                style={{
                  maxHeight: "100%",
                  margin: "0 auto",
                  display: "block"
                }}
                ref={c => (this._image = c)}
              />
            ) : null}
          </div>
        </BaseOverlay>
        <Dropzone style={this.props.style} onDrop={this._onDrop}>
          {this.props.children}
          {this.props.crop && !this.props.hideCropTip ? (
            <div style={{ fontSize: "0.9em" }}>
              Recommended size: {this.props.crop.width}w x{" "}
              {this.props.crop.height}h.
            </div>
          ) : null}
        </Dropzone>
      </div>
    );
  }
}

export default ImageDropzone;



// WEBPACK FOOTER //
// ./src/app/components/partials/image-dropzone.jsx